import { dashboardApi } from "@/core/data/api";

export default async (query) => {
  return await dashboardApi.getDashboard(query);
};
